import React from 'react'
import { Flex } from 'antd'
import GroupBySelect from './GroupBySelect'
import SubmissionSearch from './SubmissionSearch'
import SortBySelect from './SortBySelect'
import CollapseAllGroupsToggle from './CollapseAllGroupsToggle'
import TestSetToggle from '../side-section/filters/TestSetToggle'

const HeaderSection = () => {
    return (
        <Flex justify='space-between' className='mb-8' align='end'>
            <Flex gap={8} vertical>
                <TestSetToggle/>
                <SubmissionSearch />
            </Flex>
            <Flex gap={8} align='end'>
                <CollapseAllGroupsToggle />
                <SortBySelect />
                <GroupBySelect />
            </Flex>
        </Flex>
    )
}

export default HeaderSection
